<div style="height:100%; width: 100%;">

  <ion-header>
    <ion-toolbar>
      <ion-buttons *ngIf="!showXInsteadOfCloseButton" slot="start" class="menu-header" [class.remove-side-margins]="removeSideMargins">
        <ion-button fill="solid" (click)="closeMenu()" color="primary" class="close-menu-button">
          <ion-icon name="menu-sharp" slot="icon-only" class="close-menu-icon"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-button *ngIf="showXInsteadOfCloseButton" slot="end" fill="clear" shape="round" (click)="closeMenu()" class="close-menu-x-button">
        <ion-icon slot="icon-only" name="close-outline" size="large"></ion-icon>
      </ion-button>
      <ion-title class="menu-title">{{'PUZZLE.button_bar.buttons.menu_divider.title' | translate}}</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list [class.remove-side-margins]="removeSideMargins" class="menu-list">
      <div *ngFor="let btn of buttons" [display]="!!btn.tooltip" [tooltip]="btn.tooltip | translate" placement="right" show-delay="1000"
           tooltip-class="puzzle-tooltip">

        <!--&lt;!&ndash;      Show update notification button &ndash;&gt;-->
        <!--<ion-item lines="full" (click)="showUpdateNotificationDialog()" class="sidenav-button">-->
        <!--  <ion-icon class="sidenav-icon" slot="start" name="bulb-sharp" color="primary"></ion-icon>-->
        <!--  <ion-label>Updates</ion-label>-->
        <!--  -->
        <!--</ion-item>-->
        <!--&lt;!&ndash;      &ndash;&gt;-->

        <!-- Divider Buttons -->
        <ion-item-divider *ngIf="btn.divider" (click)="btn.function()">
          <ion-label>{{btn.title | translate}}</ion-label>
        </ion-item-divider>

        <!-- Regular Buttons -->
        <ion-item *ngIf="!btn.divider && !btn.custom && !btn.sweepstakeButton && !btn.slideToggleButton" lines="full"
                  class="sidenav-item sidenav-button"
                  (click)="btn.function()">
          <ion-icon class="sidenav-icon {{btn.name}}" slot="start" name="{{btn.icon}}" color="primary"></ion-icon>
          <ion-label>{{btn.title | translate}}</ion-label>
          <ion-badge slot="end" [color]="btn.matBadgeColor" *ngIf="btn.badge && !this[btn.matBadgeHidden]">{{this[btn.badge]}}</ion-badge>
        </ion-item>

        <!-- Settings Buttons -->
        <ion-item *ngIf="btn.slideToggleButton" lines="full" class="sidenav-item">
          <ion-icon class="sidenav-icon {{btn.name}}" slot="start" name="{{btn.icon}}" color="primary"></ion-icon>
          <ion-toggle class="sidenav-button"
                      [checked]="resolveState(btn.slideToggleState)"
                      (ionChange)="btn.function($event)"
                      color="primary"
                      slot="end">
          </ion-toggle>
          {{btn.title | translate}}
        </ion-item>

        <!-- Special Buttons -->
        <!--      TODO do something with these two special buttons -->
        <!--      <lib-app-puzzle-button-custom *ngIf="btn.custom" [customID]="btn.customID"></lib-app-puzzle-button-custom>-->
        <!--      <lib-app-puzzle-sweepstake-button *ngIf="btn.sweepstakeButton"></lib-app-puzzle-sweepstake-button>-->
        <!--    </div>-->
      </div>

    </ion-list>
  </ion-content>

</div>

